<template>
    <section>
        <div v-if="!success">
            <h1>로그인</h1>
            <div>
                <label>
                    <input type="text" v-model="username" placeholder="username">
                </label>
            </div>
            <div>
                <label>
                    <input type="password" v-model="password" placeholder="password">
                </label>
            </div>
            <div>
                <button @click.prevent="login">로그인</button>
            </div>
            <div v-show="loginErrorMsg" style="color: red;">{{this.loginErrorMsg}}</div>
        </div>
        <div v-if="success">
            <h1>로그인에 성공했습니다.</h1>
        </div> 
    </section>
</template>

<script>
    import loginService from '../services/loginService'

    export default {
        name: "Login",
        data: function () {
            return {
                success: false,
                loginErrorMsg: "",
                username: "",
                password: "",
            }
        },
        methods: {
            async login() {
                if(!this.username || !this.password)
                    return;

                const result = await loginService.login(this.username, this.password);
                if (result.r) {
                    this.success = true;
                    this.loginErrorMsg = '';
                } else {
                    this.success = false;
                    this.loginErrorMsg = result.msg;
                }
                console.log(result)

            }
        }
    }
</script>

<style scoped>

</style>
